import type { InterestRate } from "@justhome/api-core";

export interface MonthlyRate {
  month: string;
  label: string;
  tenYears?: number;
  fifteenYears?: number;
  twentyYears?: number;
}

const isValidRate = (rate?: number) =>
  typeof rate === "number" && Number.isFinite(rate) && rate > 0;

const toMonthlyRates = (
  observations: InterestRate[],
  months = 12,
): MonthlyRate[] => {
  const latestByMonth = new Map<string, InterestRate>();

  observations
    .filter(
      (observation) =>
        isValidRate(observation.tenYearInterestRate) &&
        Number.isFinite(Date.parse(observation.createdAt)),
    )
    .sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))
    .forEach((observation) =>
      latestByMonth.set(observation.createdAt.slice(0, 7), observation),
    );

  return [...latestByMonth.entries()]
    .sort(([a], [b]) => b.localeCompare(a))
    .slice(0, months)
    .map(([month, observation]) => ({
      month,
      label: new Date(`${month}-01T00:00:00Z`).toLocaleDateString("de-DE", {
        month: "long",
        year: "numeric",
        timeZone: "UTC",
      }),
      tenYears: observation.tenYearInterestRate,
      fifteenYears: isValidRate(observation.fifteenYearInterestRate)
        ? observation.fifteenYearInterestRate
        : undefined,
      twentyYears: isValidRate(observation.twentyYearInterestRate)
        ? observation.twentyYearInterestRate
        : undefined,
    }));
};

export default toMonthlyRates;
